module.exports = __webpack_public_path__ + "media/images/flags/64/Germany-2bc4f6b2fbd3a22426a34d1948b2925c.png";